export default __webpack_public_path__ + "images/f8e7ce7a5c968706b682c6fb017f1296.svg";